import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl} from '@angular/platform-browser';
import {News} from '../model/news';

@Pipe({
    name: 'order'
})
export class OrderPipe implements PipeTransform {

    constructor() {
    }

    public transform(all: News[]) {
        if (all === null || all.length === 0) {
            return all;
        }
        return all.sort((n1: News, n2: News) => n1.data_pubblicazione.getTime() - n2.data_pubblicazione.getTime());
    }
}
